import { render } from "./GiftPackPromptDialog.vue?vue&type=template&id=58da1b57&scoped=true"
import script from "./GiftPackPromptDialog.vue?vue&type=script&lang=js"
export * from "./GiftPackPromptDialog.vue?vue&type=script&lang=js"

import "./GiftPackPromptDialog.vue?vue&type=style&index=0&id=58da1b57&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58da1b57"]])

export default __exports__